import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage, useField, useFormikContext } from 'formik';
import { Select } from 'formik-material-ui';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';

// import utils
import { logger } from './../../../utils/utils';

import { usePermissionLevelGetListAllSetting, usePermissionLevelGetListAllWithUserRight } from './../../../hooks/useData';

/**
 * SelectPermissionLevel() (component)
 * @param {string} name, name of select element (default: category_id)
 * @param {string} id, id of select element (default: category_id)
 * @param {string} label, label of select element (default: "ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด")
 * @param {function} onChange, onChange
 * @param {string} excludeDataField, feild of data for exclude from list of permissionLevel
 * @param {array} excludeData, data of excludeDataField
 * @param {bool} disabled, default: false
 * @param {object} className, className of select element
  * @param variant
 * @returns (element) SelectPermissionLevel
 */
const SelectPermissionLevelAdmin = ({
  name = 'permission_id',
  id = 'permission_id',
  label = 'ระดับการดำเนินการ',
  onChange,
  excludeDataField = 'id',
  excludeData = [],
  disabled = false,
  className,
  variant = 'standard',
}) => {
  logger('SelectPermissionLevelAdmin render');

  // Hook Formik setFildValue
  const { setFieldValue } = useFormikContext();
  // https://formik.org/docs/api/useField (Test value from formik, instead state-value)
  const [field, meta] = useField(name);

  // Hook permissionLevel
  let permissionLevels = usePermissionLevelGetListAllWithUserRight('TH');
  if (permissionLevels && excludeData && excludeDataField) {
    permissionLevels = permissionLevels.filter(function (level) {
      return !excludeData.includes(level[excludeDataField]);
    });
  }else{
    permissionLevels=[];
  }

  // Handle change select
  const memoHandleChange = useCallback((e, c) => {
    setFieldValue(name, e.target.value);
    let context = typeof c.props.children === 'string' ? c.props.children : '';
    onChange && onChange(e, context);
  });

  return (
    <React.Fragment>
      <FormControl
        fullWidth
        error={meta.error && meta.touched}
        className={className}
        variant={variant}
        size="small"
      >
        <InputLabel htmlFor={id} style={{ backgroundColor: 'white' }}>{label}</InputLabel>
        <Field
          component={Select}
          name={name}
          inputProps={{
            id,
            name,
          }}
          onChange={memoHandleChange}
          disabled={disabled}
        >
          <MenuItem value="">
            <em>เลือก {label}</em>
          </MenuItem>
          {permissionLevels.map((level) => (
            <MenuItem value={level.id} key={level.id}>
              {level.name}
            </MenuItem>
          ))}
        </Field>
        <ErrorMessage name={name} component={FormHelperText}></ErrorMessage>
      </FormControl>
    </React.Fragment>
  );
};

// Types[, Rules] of props
SelectPermissionLevelAdmin.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  excludeDataField: PropTypes.string,
  excludeData: PropTypes.array,
};

export default React.memo(SelectPermissionLevelAdmin);
